import { actionCreatorFactory } from 'typescript-fsa';
import { DesignSet, RecommendDesignItems } from '@app/react/const/type';

const actionCreator = actionCreatorFactory();

export interface INewDesignParam {
    item: DesignSet & RecommendDesignItems;
}

export const newDesignAction = actionCreator<INewDesignParam>(
    'newDesignAction',
);
